import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { UserService } from '../../services/user.service';

export const guestGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (userService.isAuthenticated()) {
    router.navigate(['/profile/details'], { replaceUrl: true });
    return false;
  }

  return true;
};
